// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".signatureCanvas{\n position: absolute;\n top: 32px;\n width: 98%;\n height: 175px;\n}", ""]);
// Exports
module.exports = exports;
